// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Form, Row, Select, Tag } from "antd";
import FormField from "../../../components/FormField";
import { NewsThemeFormSectionProps } from "../../../types/NewsThemeTypes";
import { FIELD_LENGTH } from "../../../../utils/Constant";
import { useStore } from "effector-react";
import { BranchesStore } from "../../../../state/branches/BranchesStore";

const NewsThemeInputFormSection: React.FunctionComponent<NewsThemeFormSectionProps> = (
  props: NewsThemeFormSectionProps
) => {
  const { t } = useTranslation();

  const branchList = useStore(BranchesStore);

  const { editMode = true, createMode = false, newsTheme } = props;

  return (
    <>
      <Row>
        <Col xs={24} sm={12}>
          <FormField
            labelName={t("news_theme.name")}
            inputId="name"
            required={true}
            emptyErrorMessage={t("global.empty_error_field")}
            readOnly={!editMode}
            maxLength={FIELD_LENGTH.NAME}
          />
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name="branch"
            key="branch"
            rules={[
              {
                required: createMode,
                message: t("global.empty_error_field"),
                whitespace: true
              }
            ]}
            label={<span>{t("news_theme.branch")}</span>}
          >
            <Select
              id="branch"
              placeholder={t("add_news.theme.placeholder")}
              disabled={!createMode}
            >
              {Object.keys(branchList).map(key => (
                <Select.Option key={key} value={key}>
                  {branchList[key].label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        {newsTheme?.publicationDate && newsTheme?.isDefault && (
          <Col xs={24} sm={12}>
            <Row>
              <div style={{ height: 40 }} />
            </Row>
            <Row>
              <Tag color={"#778899"}>{t("news_theme.defaultNewsTheme")}</Tag>
            </Row>
          </Col>
        )}
      </Row>
    </>
  );
};

NewsThemeInputFormSection.defaultProps = {
  editMode: true
};

export default NewsThemeInputFormSection;
